import { useNavigate } from "react-router-dom"

const NotFoundError = () => {
  const navigate = useNavigate()
  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-2">
        <h1 className="text-[7rem] font-bold leading-tight">404</h1>
        <span className="font-medium">Oops! Page Not Found!</span>
        <p className="text-muted-foreground text-center">
          It seems like the page you're looking for <br />
          does not exist or might have been removed.
        </p>
        <div className="mt-6 flex gap-4">
          <button
            onClick={() => navigate(-1)}
            type="button"
            className="rounded-full bg-gradient-to-r from-danube to-viking px-4 py-1 font-bold text-white disabled:opacity-50"
          >
            Go Back
          </button>
          <button onClick={() => navigate("/dashboard")}>Back to Home</button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundError
